import { render, staticRenderFns } from "./Exibir.vue?vue&type=template&id=0b1727d2&"
import script from "./Exibir.vue?vue&type=script&lang=js&"
export * from "./Exibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports